module.exports = {"data":{"page":{"edges":[{"node":{"title":"Contact","metaDescription":"Meer weten, een vraag of opmerking? Neem contact met mij op: telefonisch via 0031 (0)6 19947484 of per e-mail via robin@robinvanwechem.nl","phoneDisplay":"0031 (0)6 199 474 84","phone":"0031619947484","email":"robin@robinvanwechem.nl","website":"https://www.robinvanwechem.nl","body":{"body":"Meer weten, een vraag of opmerking? Neem contact met mij op:"}}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/contact.json
// module id = 398
// module chunks = 184662623972074